import type { SerializedStyles } from '@emotion/react'
import clsx from 'clsx'
import type { StyleProps } from 'src/types'

import S from './DrawerTemplate.style'

type Props = {
  isOpen: boolean
  children: React.ReactNode
  onClose: () => void
  position?: 'left' | 'right'
  css?: SerializedStyles
  wrapperCss?: SerializedStyles
  hasOverlay?: boolean
  'data-testid'?: string
} & StyleProps

const DrawerTemplate = ({
  children,
  isOpen,
  onClose,
  className,
  style,
  css,
  wrapperCss,
  position = 'right',
  hasOverlay = true,
  'data-testid': testId,
}: Props) => {
  return (
    <S.Container className={clsx(isOpen && 'open')} css={wrapperCss}>
      <div
        className={clsx(className, position, 'drawer')}
        css={css}
        style={style}
        data-testid={testId}
      >
        {children}
      </div>
      <S.Overlay className={clsx('overlay', hasOverlay || 'no-overlay')} onClick={onClose} />
    </S.Container>
  )
}

export default DrawerTemplate
